import { Injectable } from '@angular/core';
import { BaseQuery } from '../base/base.query';
import { PageStore } from './page.store';

@Injectable({
    providedIn: 'root'
})
export class PageQuery extends BaseQuery {

    constructor(store: PageStore) {
        super(store);
    }
}
